import { createRegistry } from '../createRegistry';
export const registry = createRegistry({
    host: 'editorPlatform',
});
export default registry;
export * from '../types';
//# sourceMappingURL=editorPlatform.js.map